import { HTMLAttributes, createElement } from 'react'

export interface RichTextProps extends HTMLAttributes<HTMLDivElement> {
    rawHtml: string
    tag?: keyof HTMLElementTagNameMap
}

export const RichText = ({ rawHtml, tag = 'div', ...rest }: RichTextProps): JSX.Element => {
    return createElement(tag, {
        className: `rich-text ${rest.className || ''}`,
        dangerouslySetInnerHTML: { __html: rawHtml },
    })
}
